import React from "react";

import { BettingTypeColumnTips } from "./BettingTypeColumnTips";

export function BettingTypeColumn(props: {
	column: { displayTips: string[] };
}) {
	const { column } = props;

	if (column == null) {
		return <div className="offer__head__data offer__type">&nbsp;</div>;
	}

	return (
		<div className="offer__head__data offer__type">
			<div className="offer__type__row">
				<BettingTypeColumnTips tips={column.displayTips} />
			</div>
		</div>
	);
}
